import type { ComponentType } from 'react'

import type { Language } from 'shared/lib/i18n'

/** Each language's flag, 28×20 — taken as-is from the dashboard's language picker. */
const FLAGS: Record<Language, ComponentType<{ className?: string }>> = {
	ru: ({ className }: { className?: string }) => (
		<svg
			className={className}
			width='28'
			height='20'
			viewBox='0 0 28 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect x='0.25' y='0.25' width='27.5' height='19.5' rx='1.75' fill='white' stroke='#F5F5F5' strokeWidth='0.5' />
			<mask
				id='mask0_5778_722'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='28'
				height='20'
			>
				<rect x='0.25' y='0.25' width='27.5' height='19.5' rx='1.75' fill='white' stroke='white' strokeWidth='0.5' />
			</mask>
			<g mask='url(#mask0_5778_722)'>
				<path fillRule='evenodd' clipRule='evenodd' d='M0 13.3333H28V6.66666H0V13.3333Z' fill='#0C47B7' />
				<path fillRule='evenodd' clipRule='evenodd' d='M0 20H28V13.3333H0V20Z' fill='#E53B35' />
			</g>
		</svg>
	),
	uz: ({ className }: { className?: string }) => (
		<svg
			className={className}
			width='28'
			height='20'
			viewBox='0 0 28 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect x='0.25' y='0.25' width='27.5' height='19.5' rx='1.75' fill='white' stroke='#F5F5F5' strokeWidth='0.5' />
			<mask
				id='mask0_5778_693'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='28'
				height='20'
			>
				<rect x='0.25' y='0.25' width='27.5' height='19.5' rx='1.75' fill='white' stroke='white' strokeWidth='0.5' />
			</mask>
			<g mask='url(#mask0_5778_693)'>
				<path fillRule='evenodd' clipRule='evenodd' d='M0 6.66667H28V0H0V6.66667Z' fill='#04AAC8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M0 20H28V13.3333H0V20Z' fill='#23C840' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.66663 5.33334C5.07791 5.33334 5.46019 5.2092 5.77805 4.99634C5.74122 4.99878 5.70407 5.00001 5.66663 5.00001C4.74615 5.00001 3.99996 4.25382 3.99996 3.33334C3.99996 2.41287 4.74615 1.66668 5.66663 1.66668C5.70407 1.66668 5.74122 1.66791 5.77805 1.67034C5.46019 1.45749 5.07791 1.33334 4.66663 1.33334C3.56206 1.33334 2.66663 2.22877 2.66663 3.33334C2.66663 4.43791 3.56206 5.33334 4.66663 5.33334ZM7.99996 4.66668C7.99996 5.03487 7.70148 5.33334 7.33329 5.33334C6.9651 5.33334 6.66663 5.03487 6.66663 4.66668C6.66663 4.29849 6.9651 4.00001 7.33329 4.00001C7.70148 4.00001 7.99996 4.29849 7.99996 4.66668ZM9.99996 2.66668C10.3681 2.66668 10.6666 2.3682 10.6666 2.00001C10.6666 1.63182 10.3681 1.33334 9.99996 1.33334C9.63177 1.33334 9.33329 1.63182 9.33329 2.00001C9.33329 2.3682 9.63177 2.66668 9.99996 2.66668ZM13.3333 2.00001C13.3333 2.3682 13.0348 2.66668 12.6666 2.66668C12.2984 2.66668 12 2.3682 12 2.00001C12 1.63182 12.2984 1.33334 12.6666 1.33334C13.0348 1.33334 13.3333 1.63182 13.3333 2.00001ZM12.6666 5.33334C13.0348 5.33334 13.3333 5.03487 13.3333 4.66668C13.3333 4.29849 13.0348 4.00001 12.6666 4.00001C12.2984 4.00001 12 4.29849 12 4.66668C12 5.03487 12.2984 5.33334 12.6666 5.33334ZM10.6666 4.66668C10.6666 5.03487 10.3681 5.33334 9.99996 5.33334C9.63177 5.33334 9.33329 5.03487 9.33329 4.66668C9.33329 4.29849 9.63177 4.00001 9.99996 4.00001C10.3681 4.00001 10.6666 4.29849 10.6666 4.66668Z'
					fill='white'
				/>
			</g>
		</svg>
	),
	en: ({ className }: { className?: string }) => (
		<svg
			className={className}
			width='28'
			height='20'
			viewBox='0 0 28 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect width='28' height='20' rx='2' fill='white' />
			<mask
				id='mask0_5778_660'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='28'
				height='20'
			>
				<rect width='28' height='20' rx='2' fill='white' />
			</mask>
			<g mask='url(#mask0_5778_660)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z'
					fill='#D02F44'
				/>
				<rect width='12' height='9.33333' fill='#46467F' />
				<g filter='url(#filter0_d_5778_660)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M2.66671 2.00001C2.66671 2.3682 2.36823 2.66668 2.00004 2.66668C1.63185 2.66668 1.33337 2.3682 1.33337 2.00001C1.33337 1.63182 1.63185 1.33334 2.00004 1.33334C2.36823 1.33334 2.66671 1.63182 2.66671 2.00001ZM5.33337 2.00001C5.33337 2.3682 5.0349 2.66668 4.66671 2.66668C4.29852 2.66668 4.00004 2.3682 4.00004 2.00001C4.00004 1.63182 4.29852 1.33334 4.66671 1.33334C5.0349 1.33334 5.33337 1.63182 5.33337 2.00001ZM7.33337 2.66668C7.70156 2.66668 8.00004 2.3682 8.00004 2.00001C8.00004 1.63182 7.70156 1.33334 7.33337 1.33334C6.96518 1.33334 6.66671 1.63182 6.66671 2.00001C6.66671 2.3682 6.96518 2.66668 7.33337 2.66668ZM10.6667 2.00001C10.6667 2.3682 10.3682 2.66668 10 2.66668C9.63185 2.66668 9.33337 2.3682 9.33337 2.00001C9.33337 1.63182 9.63185 1.33334 10 1.33334C10.3682 1.33334 10.6667 1.63182 10.6667 2.00001ZM3.33337 4.00001C3.70156 4.00001 4.00004 3.70153 4.00004 3.33334C4.00004 2.96515 3.70156 2.66668 3.33337 2.66668C2.96518 2.66668 2.66671 2.96515 2.66671 3.33334C2.66671 3.70153 2.96518 4.00001 3.33337 4.00001ZM6.66671 3.33334C6.66671 3.70153 6.36823 4.00001 6.00004 4.00001C5.63185 4.00001 5.33337 3.70153 5.33337 3.33334C5.33337 2.96515 5.63185 2.66668 6.00004 2.66668C6.36823 2.66668 6.66671 2.96515 6.66671 3.33334ZM8.66671 4.00001C9.0349 4.00001 9.33337 3.70153 9.33337 3.33334C9.33337 2.96515 9.0349 2.66668 8.66671 2.66668C8.29852 2.66668 8.00004 2.96515 8.00004 3.33334C8.00004 3.70153 8.29852 4.00001 8.66671 4.00001ZM10.6667 4.66668C10.6667 5.03487 10.3682 5.33334 10 5.33334C9.63185 5.33334 9.33337 5.03487 9.33337 4.66668C9.33337 4.29849 9.63185 4.00001 10 4.00001C10.3682 4.00001 10.6667 4.29849 10.6667 4.66668ZM7.33337 5.33334C7.70156 5.33334 8.00004 5.03487 8.00004 4.66668C8.00004 4.29849 7.70156 4.00001 7.33337 4.00001C6.96518 4.00001 6.66671 4.29849 6.66671 4.66668C6.66671 5.03487 6.96518 5.33334 7.33337 5.33334ZM5.33337 4.66668C5.33337 5.03487 5.0349 5.33334 4.66671 5.33334C4.29852 5.33334 4.00004 5.03487 4.00004 4.66668C4.00004 4.29849 4.29852 4.00001 4.66671 4.00001C5.0349 4.00001 5.33337 4.29849 5.33337 4.66668ZM2.00004 5.33334C2.36823 5.33334 2.66671 5.03487 2.66671 4.66668C2.66671 4.29849 2.36823 4.00001 2.00004 4.00001C1.63185 4.00001 1.33337 4.29849 1.33337 4.66668C1.33337 5.03487 1.63185 5.33334 2.00004 5.33334ZM4.00004 6.00001C4.00004 6.3682 3.70156 6.66668 3.33337 6.66668C2.96518 6.66668 2.66671 6.3682 2.66671 6.00001C2.66671 5.63182 2.96518 5.33334 3.33337 5.33334C3.70156 5.33334 4.00004 5.63182 4.00004 6.00001ZM6.00004 6.66668C6.36823 6.66668 6.66671 6.3682 6.66671 6.00001C6.66671 5.63182 6.36823 5.33334 6.00004 5.33334C5.63185 5.33334 5.33337 5.63182 5.33337 6.00001C5.33337 6.3682 5.63185 6.66668 6.00004 6.66668ZM9.33337 6.00001C9.33337 6.3682 9.0349 6.66668 8.66671 6.66668C8.29852 6.66668 8.00004 6.3682 8.00004 6.00001C8.00004 5.63182 8.29852 5.33334 8.66671 5.33334C9.0349 5.33334 9.33337 5.63182 9.33337 6.00001ZM10 8.00001C10.3682 8.00001 10.6667 7.70153 10.6667 7.33334C10.6667 6.96515 10.3682 6.66668 10 6.66668C9.63185 6.66668 9.33337 6.96515 9.33337 7.33334C9.33337 7.70153 9.63185 8.00001 10 8.00001ZM8.00004 7.33334C8.00004 7.70153 7.70156 8.00001 7.33337 8.00001C6.96518 8.00001 6.66671 7.70153 6.66671 7.33334C6.66671 6.96515 6.96518 6.66668 7.33337 6.66668C7.70156 6.66668 8.00004 6.96515 8.00004 7.33334ZM4.66671 8.00001C5.0349 8.00001 5.33337 7.70153 5.33337 7.33334C5.33337 6.96515 5.0349 6.66668 4.66671 6.66668C4.29852 6.66668 4.00004 6.96515 4.00004 7.33334C4.00004 7.70153 4.29852 8.00001 4.66671 8.00001ZM2.66671 7.33334C2.66671 7.70153 2.36823 8.00001 2.00004 8.00001C1.63185 8.00001 1.33337 7.70153 1.33337 7.33334C1.33337 6.96515 1.63185 6.66668 2.00004 6.66668C2.36823 6.66668 2.66671 6.96515 2.66671 7.33334Z'
						fill='url(#paint0_linear_5778_660)'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_5778_660'
					x='1.33337'
					y='1.33334'
					width='9.33337'
					height='7.66666'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5778_660' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5778_660' result='shape' />
				</filter>
				<linearGradient
					id='paint0_linear_5778_660'
					x1='1.33337'
					y1='1.33334'
					x2='1.33337'
					y2='8.00001'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='#F0F0F0' />
				</linearGradient>
			</defs>
		</svg>
	),
}

export function Flag({ lang, className }: { lang: Language; className?: string }) {
	const Svg = FLAGS[lang]
	return <Svg className={className} />
}
